import { render } from "./InfosStaff.vue?vue&type=template&id=5992987a&scoped=true"
import script from "./InfosStaff.vue?vue&type=script&lang=js"
export * from "./InfosStaff.vue?vue&type=script&lang=js"

import "./InfosStaff.vue?vue&type=style&index=0&id=5992987a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5992987a"]])

export default __exports__